import { useState, useEffect } from "react";
import { useCallbackRef } from "./use-callback-ref";
import { useEventListener } from "./use-event-listener";

/**
 * Uses a key press event.
 *
 * @deprecated Use the `useHotKeys` hook.
 */
export function useKeyPress(key, callback) {
  const savedCallback = useCallbackRef(callback);
  const [keyPressed, setKeyPressed] = useState(false);
  useEventListener("keydown", event => {
    const keyEvent = event;
    if (isValidEvent(keyEvent) && keyEvent.key === key && !keyPressed) {
      setKeyPressed(true);
    }
  }, window, true);
  useEventListener("keyup", event => {
    const keyEvent = event;
    if (isValidEvent(keyEvent) && keyEvent.key === key && keyPressed) {
      setKeyPressed(false);
    }
  }, window, true);
  useEffect(() => {
    if (keyPressed) {
      savedCallback();
    }
  }, [keyPressed]);
}
function isValidEvent(event) {
  const el = event.target;
  return !event.repeat && !el.isContentEditable && el.tagName !== "INPUT" && el.tagName !== "SELECT" && el.tagName !== "TEXTAREA";
}